import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/tokens.scss";
import "./assets/css/main.scss";
import "./assets/css/wallet-design-system.css";
// leaflet/dist/leaflet.css is now imported locally by the map-using
// components (DevicePunchHistory, sharedComponent/map.jsx, storeMap.js)
// so it's only downloaded when a map page is actually visited.

// import "./assets/css/CreateUser.scss"

// === Framework & router (eager) ===
import React, { lazy, Suspense, useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// === Contexts (eager — provider/consumer wiring must resolve at boot) ===
import { AppContext } from "./context/AppContext";
import { AuthProvider as WalletAuthProvider } from "./context/wallet/WalletAuthContext";

// === Shared chrome rendered outside <Routes> (eager) ===
import Header from "./sharedComponent/Header";
import Sidebar from "./sharedComponent/Sidebar";
import Calling from "./sharedComponent/Calling";

// === Login kept eager so the entry route paints without a Suspense fallback flash ===
import Login from "./pages/AuthPages/Login";

// ── Wallet Module ─────────────────────────────────────────────────
// (Duplicate CSS import preserved from original to keep byte-equivalent behaviour.)
import "./assets/css/wallet-design-system.css";

// ── Lazy-loaded route components ──────────────────────────────────
const AbortTask = lazy(() => import("./pages/TaskManagement/AbortTask"));
const AboutOrgan = lazy(() => import("./pages/Organisation/AboutOrgan"));
const Achivements = lazy(() => import("./pages/Achivements/Achivements"));
const AddEmployee = lazy(() => import("./pages/Employee/AddEmployee"));
const AddEmployeeAttendanceReport = lazy(() => import("./pages/attendence/AddEmployeeAttendance"));
const AddProductStock = lazy(() => import("./pages/Employee_Wallet/AddProductStock"));
const Addwebsite = lazy(() => import("./pages/CRMOfficeCaller/Addwebsite"));
const Admin = lazy(() => import("./pages/CRMOfficeCaller/Admin"));
const AdminEdit = lazy(() => import("./pages/CRMOfficeCaller/AdminEdit"));
const Adminpanel = lazy(() => import("./pages/CRMOfficeCaller/Adminpanel"));
const AgentAssignedCalls = lazy(() => import("./pages/CRMphonebook/Agentassignedcalls"));
const AgentCallSummary = lazy(() => import("./pages/CRMphonebook/AgentCallSummary"));
const AgentCallSummaryDetails = lazy(() => import("./pages/CRMphonebook/AgentCallSummaryDetails"));
const AgentList = lazy(() => import("./pages/CRMphonebook/AgentList"));
const AgentcallList = lazy(() => import("./pages/CRMphonebook/AgentcallList"));
const AllAnnouncement = lazy(() => import("./pages/Notifications/AllAnnouncement"));
const AssignCallUsers = lazy(() => import("./pages/CRMphonebook/AssignCallUsers"));
const AssignRole = lazy(() => import("./pages/userManagement/AssignRole"));
const BenchList = lazy(() => import("./pages/complaince/BenchList"));
const BulkCallView = lazy(() => import("./pages/CRMphonebook/BulkCallView"));
const BulkUpload = lazy(() => import("./pages/CRMOfficeCaller/BulkUpload"));
const CRMCalls = lazy(() => import("./pages/CRMphonebook/CRMCalls"));
const CRMDashboard = lazy(() => import("./pages/CRMOfficeCaller/CRMDashboard"));
const Call = lazy(() => import("./pages/Communication/Call"));
const CallHistory = lazy(() => import("./pages/CRMphonebook/CallHistory"));
const CallReport = lazy(() => import("./pages/CRMphonebook/CallReport"));
const CallingScreen = lazy(() => import("./pages/Communication/Calling"));
const Campaign = lazy(() => import("./pages/CRMOfficeCaller/Campaign"));
const CandidatesData = lazy(() => import("./pages/CRMphonebook/CandidatesData"));
const Canteen = lazy(() => import("./pages/Employee_Wallet/Canteen"));
const Categories = lazy(() => import("./pages/Employee_Wallet/Categories"));
const TaskPlanerr = lazy(() => import("./pages/TaskManagement/taskPlaner/taskPlaner"));
const CategoriesOfficeCaller = lazy(() => import("./pages/CRMOfficeCaller/CategoriesOfficeCaller"));
const ChangePassword = lazy(() => import("./pages/AuthPages/ChangePassword"));
const Chat = lazy(() => import("./pages/Communication/Chat"));
const ChatHistory = lazy(() => import("./pages/Communication/ChatHistory"));
const ClientManagement = lazy(() => import("./pages/ClientManagement/ClientManagement"));
const CompleteTask = lazy(() => import("./pages/TaskManagement/CompleteTask"));
const ComplianceSetting = lazy(() => import("./pages/complaince/ComplianceSetting"));
const CreateAccount = lazy(() => import("./pages/AuthPages/CreateAccount"));
const CreateCategories = lazy(() => import("./pages/Employee_Wallet/CreateCategories"));
const CreateProducts = lazy(() => import("./pages/Employee_Wallet/CreateProducts"));
const CreateTeam = lazy(() => import("./pages/TeamsPreference/CreateTeam"));
const CreateToken = lazy(() => import("./pages/CRMphonebook/CreateToken"));
const CrmApp = lazy(() => import("./pages/CRMOfficeCaller/CrmApp"));
const CrmPushNotification = lazy(() => import("./pages/CRMOfficeCaller/CrmPushNotification"));
const CrmSendgrid = lazy(() => import("./pages/CRMOfficeCaller/CrmSendgrid"));
const CrmWebsite = lazy(() => import("./pages/CRMOfficeCaller/Crmwebsite"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const DevicePunchHistory = lazy(() => import("./pages/attendence/DevicePunchHistory"));
const Domains = lazy(() => import("./pages/CRMOfficeCaller/Domains"));
const DownloadAgentReport = lazy(() => import("./pages/CRMphonebook/DownloadAgentReport"));
const EditEmployeeProfile = lazy(() => import("./pages/Employee/EditEmployeeProfile"));
const EmailReport = lazy(() => import("./pages/CRMOfficeCaller/EmailReport"));
const EmployeeAttendence = lazy(() => import("./pages/attendence/EmployeeAttendence"));
const EmployeeAttendenceReport = lazy(() => import("./pages/attendence/EmployeeAttendenceReport"));
const EmployeeCode = lazy(() => import("./pages/complaince/EmployeeCode"));
const EmployeeTimesheetDetails = lazy(() => import("./pages/Document/EmployeeTimesheetDetails"));
const EmpoloyeeWallet = lazy(() => import("./pages/Employee_Wallet/EmpoloyeeWallet"));
const EnquiryDetails = lazy(() => import("./pages/CRMOfficeCaller/EnquiryDetails"));
const FaceDetection = lazy(() => import("./pages/attendence/FaceDetection"));
const Features = lazy(() => import("./pages/CRMOfficeCaller/Features"));
const Files = lazy(() => import("./pages/Communication/Files"));
const ForgotPassword = lazy(() => import("./pages/AuthPages/ForgotPassword"));
const FrequentCaller = lazy(() => import("./pages/CRMphonebook/FrequentCaller"));
const GeneralSetting = lazy(() => import("./pages/complaince/GeneralSetting"));
const GenerateSalarySlip = lazy(() => import("./pages/ProjectCosting/GenerateSalarySlip"));

const SalaryMasterRoll = lazy(() => import("./pages/ProjectCosting/SalaryMasterRoll"));
const HourlySalaryMusterRoll = lazy(() => import("./pages/ProjectCosting/HourlySalaryMusterRoll"));
const SalaryCalculator = lazy(() => import("./pages/salary-calculator"));
const Styleguide = lazy(() => import("./pages/_dev/Styleguide"));
const GoogleAnalytics = lazy(() => import("./pages/CRMOfficeCaller/GoogleAnalytics"));
const HoldTask = lazy(() => import("./pages/TaskManagement/HoldTask"));
const Holidays = lazy(() => import("./pages/Organisation/Holidays"));
const HolidaysAndEvents = lazy(() => import("./pages/Notifications/HolidaysAndEvents"));
const InvalidLeads = lazy(() => import("./pages/CRMOfficeCaller/InvalidLeads"));
const IssueCard = lazy(() => import("./pages/Employee_Wallet/IssueCard"));
const LeadListCount = lazy(() => import("./pages/CRMOfficeCaller/LeadListCount"));
const LeadManagement = lazy(() => import("./pages/CRMOfficeCaller/LeadManagement"));
const LeadManagementListEdit = lazy(() => import("./pages/CRMOfficeCaller/LeadManagementListEdit"));
const Leave = lazy(() => import("./pages/leave/Leave"));
const EmployeeLeave = lazy(() => import("./pages/leave/employeeLeave"));
const LeaveApprove = lazy(() => import("./pages/leave/LeaveApprove"));
const List = lazy(() => import("./pages/Employee/List"));
const ManageDepartments = lazy(() => import("./pages/Organisation/ManageDepartments"));
const ManageDesignations = lazy(() => import("./pages/Organisation/ManageDesignations"));
const ManageLocations = lazy(() => import("./pages/Organisation/ManageLocations"));
const ManageShift = lazy(() => import("./pages/Organisation/ManageShift"));
const ManageTeam = lazy(() => import("./pages/TeamsPreference/ManageTeam"));
const Meetings = lazy(() => import("./pages/Communication/Meetings"));
const Modules = lazy(() => import("./pages/CRMOfficeCaller/Modules"));
const MyAnnouncement = lazy(() => import("./pages/Notifications/MyAnnouncement"));
const MyAttendence = lazy(() => import("./pages/attendence/MyAttendance"));
const MyDiary = lazy(() => import("./pages/Timesheet/MyDiary"));
const NotCallClassification = lazy(() => import("./pages/CRMphonebook/NotCallClassification"));
const OngoingCalls = lazy(() => import("./pages/Communication/OngoingCalls"));
const Organisational = lazy(() => import("./pages/Document/Organisational"));
const OrganizationDetails = lazy(() => import("./pages/Organisation/OrganizationDetails"));
const Permission = lazy(() => import("./pages/userManagement/Permission"));
const Personal = lazy(() => import("./pages/Document/Personal"));
const PrivacyPolicy = lazy(() => import("./pages/Organisation/PrivacyPolicy"));
const Product = lazy(() => import("./pages/Employee_Wallet/Product"));
const ProductStock = lazy(() => import("./pages/Employee_Wallet/ProductStock"));
const Profile = lazy(() => import("./pages/Dashboard/Profile"));
const ProjectAssigned = lazy(() => import("./pages/complaince/ProjectAssigned"));
const ProjectAssignment = lazy(() => import("./pages/Document/ProjectAssignment"));
const ProjectChannels = lazy(() => import("./pages/Communication/ProjectChannels"));
const ProjectCost = lazy(() => import("./pages/ProjectCosting/ProjectCost"));
const ProjectCostEnd = lazy(() => import("./pages/ProjectCosting/ProjectCostEnd"));
const ProjectCostReport = lazy(() => import("./pages/ProjectCosting/ProjectCostReport"));
const ProjectDeAssign = lazy(() => import("./pages/complaince/ProjectDeAssign"));
const ProjectDetails = lazy(() => import("./pages/Document/ProjectDetails"));
const ProjectDocumentation = lazy(() => import("./pages/Document/ProjectDocumentation"));
const ProjectNotAssigned = lazy(() => import("./pages/complaince/ProjectNotAssigned"));
const ProjectResources = lazy(() => import("./pages/Document/ProjectResources"));
const ProjectSchedule = lazy(() => import("./pages/Document/ProjectSchedule"));
const ProjectTask = lazy(() => import("./pages/TaskManagement/ProjectTask"));
const ProjectTimesheetDetails = lazy(() => import("./pages/Document/ProjectTiemsheetDetails"));
const Projects = lazy(() => import("./pages/Document/Projects"));
const ProposalAttachement = lazy(() => import("./pages/CRMOfficeCaller/ProposalAttachement"));
const QueryCases = lazy(() => import("./pages/CRMOfficeCaller/QueryaCases"));
const RechargeWallet = lazy(() => import("./pages/Employee_Wallet/RechargeWallet"));
const RegisterUserDetails = lazy(() => import("./pages/CRMphonebook/RegisterUserDetails"));
const Role = lazy(() => import("./pages/userManagement/Role"));
const SalaryStructure = lazy(() => import("./pages/ProjectCosting/SalaryStructure"));
const SalaryStructureWizard = lazy(() => import("./pages/ProjectCosting/SalaryStructureWizard"));
const SalesInternationalcall = lazy(() => import("./pages/CRMphonebook/SalesInternationalcall"));
const ServiceRequest = lazy(() => import("./pages/CRMphonebook/ServiceRequest"));
const ShortListTask = lazy(() => import("./pages/Timesheet/ShortListTask"));
const StandardTask = lazy(() => import("./pages/TaskManagement/StandardTask"));
const Store = lazy(() => import("./pages/Employee_Wallet/Store"));
const Task = lazy(() => import("./pages/TaskManagement/Task"));
const TaskAllocation = lazy(() => import("./pages/TaskManagement/TaskAllocation"));
const TaskApprove = lazy(() => import("./pages/TaskManagement/TaskApprove"));
const TaskList = lazy(() => import("./pages/TaskManagement/TaskList"));
const TaskNotAddedAgainstProject = lazy(() => import("./pages/complaince/TaskNotAddedAgainstProject"));
const TaskNotApproved = lazy(() => import("./pages/complaince/TaskNotApproved"));
const TaskPlanner = lazy(() => import("./pages/TaskManagement/TaskPlanner"));
const TeamChart = lazy(() => import("./pages/Team-Chart/TeamChart"));
const TeamNotAssigned = lazy(() => import("./pages/complaince/TeamNotAssigned"));
const TeamTask = lazy(() => import("./pages/TaskManagement/TeamTask"));
const Teams = lazy(() => import("./pages/Communication/Teams"));
const TearmsAmdCondiation = lazy(() => import("./pages/Organisation/TearmsAmdCondiation"));
const TechCount = lazy(() => import("./pages/CRMphonebook/TechCount"));
const TimePeriodOver = lazy(() => import("./pages/complaince/TimePeriodOver"));
const Timesheet = lazy(() => import("./pages/Timesheet/Timesheet"));
const TimesheetApproval = lazy(() => import("./pages/Timesheet/TimesheetApproval"));
const TimesheetHistory = lazy(() => import("./pages/Timesheet/TimesheetHistory"));
const TimesheetNotApproved = lazy(() => import("./pages/complaince/TimesheetNotApproved"));
const TimesheetNotEntered = lazy(() => import("./pages/complaince/TimesheetNotEntered"));
const TransactionReceipt = lazy(() => import("./pages/Employee_Wallet/TransactionReceipt"));
const TwoPlusProjectsAssigned = lazy(() => import("./pages/complaince/TwoPlusProjectsAssigned"));
const UpdateUserDetails = lazy(() => import("./pages/CRMphonebook/UpdateUserDetails"));
const Updatewhatsapp = lazy(() => import("./pages/CRMphonebook/Updatewhatsapp"));
const UploadCandidateOld = lazy(() => import("./pages/CRMphonebook/UploadCandidateOld"));
const UserActivity = lazy(() => import("./pages/complaince/UserActivity"));
const UserDetails = lazy(() => import("./pages/Organisation/UserDetails"));
const UserDetailsForm = lazy(() => import("./pages/CRMphonebook/UserDetailsForm"));
const UserLastLogin = lazy(() => import("./pages/complaince/UserLastLogin"));
const UserNotLogin = lazy(() => import("./pages/complaince/UserNotLogin"));
const UserTracking = lazy(() => import("./pages/attendence/UserTracking"));
const UserdetailsAgent = lazy(() => import("./pages/CRMphonebook/UserdetailsAgent"));
const Users = lazy(() => import("./pages/CRMphonebook/Users"));
const ViewCategory = lazy(() => import("./pages/CRMOfficeCaller/ViewCategory"));
const ViewDomain = lazy(() => import("./pages/CRMOfficeCaller/ViewDomain"));
const ViewFeatures = lazy(() => import("./pages/CRMOfficeCaller/ViewFeature"));
const ViewModule = lazy(() => import("./pages/CRMOfficeCaller/ViewModule"));
const ViewList = lazy(() => import("./pages/ClientManagement/ViewList"));
const WalletRecharge = lazy(() => import("./pages/Employee_Wallet/WalletRecharge"));
const WalletSales = lazy(() => import("./pages/Employee_Wallet/WalletSales"));
const WhatsappSetting = lazy(() => import("./pages/CRMphonebook/WhatsappSetting"));
const ZeroCallList = lazy(() => import("./pages/CRMphonebook/ZeroCallList"));
const NonFunctionalFeatures = lazy(() => import("./pages/CRMOfficeCaller/NonFunctionalFeatures"));
const ViewNonFunctionalFeatures = lazy(() => import("./pages/CRMOfficeCaller/ViewNonFunctionalFeatures"));
const ConsultantandSupplier = lazy(() => import("./pages/CRMphonebook/Consultantandsupplier"));
const Consultant = lazy(() => import("./pages/CRMphonebook/Consultant"));
const Supplier = lazy(() => import("./pages/CRMphonebook/Supplier"));
const CreateGroup = lazy(() => import("./pages/CRMOfficeCaller/CreateGroup"));
const EditGroup = lazy(() => import("./pages/CRMOfficeCaller/EditGroup"));
const ContactCustomGroup = lazy(() => import("./pages/CRMOfficeCaller/ContactCustomGroup"));
const DefaultGroup = lazy(() => import("./pages/CRMOfficeCaller/DefaultGroup"));
const ContactCustomGroupDetails = lazy(() => import("./pages/CRMOfficeCaller/ContactCustomGroupDetails"));
const DefaultGroupDetails = lazy(() => import("./pages/CRMOfficeCaller/DefaultGroupDetails"));
const OrganizationRegistration = lazy(() => import("./pages/AuthPages/organizationRegistration"));
const ShiftTime = lazy(() => import("./pages/Organisation/shiftTime"));
const WhatsappPromotion = lazy(() => import("./pages/CRMphonebook/WhatsappPromotion"));
const Academic = lazy(() => import("./pages/Organisation/Academic"));
const CalendarSettings = lazy(() => import("./pages/Organisation/CalendarSettings"));
const BulkUploadOfficeCaller = lazy(() => import("./pages/CRMphonebook/BulkUploadOfficeCaller"));
const CustomGroup = lazy(() => import("./pages/CRMphonebook/CustomGroup"));
const OrganizationInfo = lazy(() => import("./pages/Organisation/OrganizationInfo"));
const OrgDetails = lazy(() => import("./pages/Organisation/OrgInfo/OrgDetails"));
const ManageDept = lazy(() => import("./pages/Organisation/OrgInfo/ManageDept"));
const ManageDesig = lazy(() => import("./pages/Organisation/OrgInfo/ManageDesig"));
const ManageLoc = lazy(() => import("./pages/Organisation/OrgInfo/ManageLocations"));
const LeaveSetting = lazy(() => import("./pages/Organisation/LeaveSetting"));
const PaymentGateway = lazy(() => import("./pages/Organisation/Paymentgateway"));
const SMSGateway = lazy(() => import("./pages/Organisation/SMSgateway"));
const IVRSetting = lazy(() => import("./pages/Organisation/IVRSetting"));
const CreateIVR = lazy(() => import("./pages/Organisation/CreateIVR"));
const UpdateIVR = lazy(() => import("./pages/Organisation/UpdateIVR"));
const Setting = lazy(() => import("./pages/ChatAdmin/setting/Setting"));
const AccessCode = lazy(() => import("./pages/ChatAdmin/Accesscode/AccessCode"));
const AddQuestions = lazy(() => import("./pages/ChatAdmin/AddQuestions/AddQuestions"));
const QuestionListing = lazy(() => import("./pages/ChatAdmin/QuestionListing/QuestionListing"));
const AddSettings = lazy(() => import("./pages/ChatAdmin/setting/AddSetting"));
const UnAnsweredListing = lazy(() => import("./pages/ChatAdmin/unanswered/unanswerd"));
const TraineeQues = lazy(() => import("./pages/ChatAdmin/traineeques/TraineeQues"));
const ConversationFlow = lazy(() => import("./pages/ChatAdmin/conversationflow/conversationflow"));
const AddConversationFlow = lazy(() => import("./pages/ChatAdmin/conversationflow/AddConversationflow"));
const AdminChat = lazy(() => import("./pages/ChatAdmin/chat/AdminChat"));
const DataStat = lazy(() => import("./pages/ChatAdmin/Data Statistics/DataStat"));
const SubModuleDataStat = lazy(() => import("./pages/ChatAdmin/Data Statistics/SubmoduleDataStat"));
const EmplooyeDocument = lazy(() => import("./pages/Employee/EmplooyeDocumet"));
const TaskDetials = lazy(() => import("./pages/TaskManagement/TaskDetials"));
const ClientList = lazy(() => import("./pages/ClientManagement/ClientList"));
const ServiceMapping = lazy(() => import("./pages/ClientManagement/ServiceMapping"));
const Subscription = lazy(() => import("./pages/ClientManagement/Subscription"));
const Feedback = lazy(() => import("./pages/ClientManagement/Feedback"));
const ClientDetails = lazy(() => import("./pages/ClientManagement/ClientDetails"));
const UserFeedBack = lazy(() => import("./pages/ChatAdmin/userFeedback/userFeedBakc"));
const Topics = lazy(() => import("./pages/ChatAdmin/Data Statistics/topic"));
const ServiceGroup = lazy(() => import("./pages/ServiceManagement/ServiceGroup"));
const Service = lazy(() => import("./pages/ServiceManagement/Service"));
const RateTable = lazy(() => import("./pages/ServiceManagement/RateTable"));
const AccountsPaymentReciept = lazy(() => import("./pages/AccountReceivable/AccountsPaymentReciept"));
const EntitiesList = lazy(() => import("./pages/ClientManagement/EntitiesList"));
const BranchList = lazy(() => import("./pages/ClientManagement/BranchList"));
const BankList = lazy(() => import("./pages/ClientManagement/BankList"));
const ShiftManagment = lazy(() => import("./pages/ClientManagement/ShiftManagment"));
const AccountsMoneyReciept = lazy(() => import("./pages/AccountReceivable/AccountsMoneyReciept"));
const InvoiceGenerate = lazy(() => import("./pages/AccountReceivable/InvoiceGenerate"));
const AccountsGenerateInvoice = lazy(() => import("./pages/AccountReceivable/AccountsGenerateInvoice"));
const CreateQuote = lazy(() => import("./pages/Quotation/CreateQuote"));
const Quotation = lazy(() => import("./pages/Quotation/Quotation"));
const QuotationStatus = lazy(() => import("./pages/Quotation/QuotationStatus"));
const UpdateQuote = lazy(() => import("./pages/Quotation/UpdateQuote"));
const StatisticsReports = lazy(() => import("./pages/Quotation/StatisticsReports"));
const WorkFlow = lazy(() => import("./pages/workflow/workflow"));
const Ledger = lazy(() => import("./pages/AccountReceivable/Ledger"));
const SettlementReport = lazy(() => import("./pages/AccountReceivable/SettlementReport"));
const SubcriptionList = lazy(() => import("./pages/SubscriptionMgt/SubcriptionList"));
const CompleteTaskDynamic = lazy(() => import("./pages/TaskManagement/complettaskDynamic"));
const Completedworkflows = lazy(() => import("./pages/workflow/⁠completedworkflows"));
const CompleteWorkflowTaskList = lazy(() => import("./pages/workflow/workflowTaskList"));
const ViewTransactions = lazy(() => import("./pages/AccountReceivable/ViewTransactions"));
const Workflowdeshboard = lazy(() => import("./pages/workflow/workflowdeshboard"));
const Ivrgetewway = lazy(() => import("./pages/Organisation/Ivrgetewway"));
const Execution = lazy(() => import("./pages/workflow/execution"));
const DefineWorkFlow = lazy(() => import("./pages/workflow/defined"));
const UserLikeDislike = lazy(() => import("./pages/ChatAdmin/userFeedback/likedislike"));
const WorkFlowMapping = lazy(() => import("./pages/workflow/workflowmapping"));
// Named export — convert to default for React.lazy compatibility
const WorkflowChart = lazy(() =>
  import("./pages/workflow/workflow.chart").then((m) => ({ default: m.WorkflowChart }))
);
const Stock = lazy(() => import("./pages/Inventory Management System/Stock/Stock"));
const ManageStore = lazy(() => import("./pages/Inventory Management System/StoreManagement/StoreManagement"));
const AddNewStore = lazy(() => import("./pages/Inventory Management System/StoreManagement/AddNewStore"));
const OnlineOrderActivity = lazy(() => import("./pages/Inventory Management System/Onlineorderactivity/Onlineorderactivity"));
const MenuOnOff = lazy(() => import("./pages/Inventory Management System/MenuOnOff/MenuOnOff"));
const BaseMenu = lazy(() => import("./pages/Inventory Management System/BaseMenu/BaseMenu"));
const Categorymanagement = lazy(() => import("./pages/Inventory Management System/Category/Categorymanagement"));
const Editcategory = lazy(() => import("./pages/Inventory Management System/Category/Editcategory"));
const Addvariant = lazy(() => import("./pages/Inventory Management System/Variations/Addvariant"));
const UpdateVariant = lazy(() => import("./pages/Inventory Management System/Variations/UpdateVariant"));
const Addtax = lazy(() => import("./pages/Inventory Management System/Tax/Addtax"));
const Edittax = lazy(() => import("./pages/Inventory Management System/Tax/Edittax"));
const AddItems = lazy(() => import("./pages/Inventory Management System/Items/AddItems/AddItems"));
const AddAddon = lazy(() => import("./pages/Inventory Management System/Toptab/AddAddon"));
const AddTable = lazy(() => import("./pages/Inventory Management System/TextArea/AddTable"));
const AddDiscount = lazy(() => import("./pages/Inventory Management System/Toptab/AddDiscount"));
const AddArea = lazy(() => import("./pages/Inventory Management System/TextArea/AddArea"));
const TestCases = lazy(() => import("./pages/ChatAdmin/TestCases"));
const EditCase = lazy(() => import("./pages/ChatAdmin/userFeedback/EditCase"));
const TestDataStatic = lazy(() => import("./pages/ChatAdmin/TestDataStatic"));
const TestunAnsweredCase = lazy(() => import("./pages/ChatAdmin/TestunAnsweredCase"));
const TestAnsweredEdit = lazy(() => import("./pages/ChatAdmin/TestAnsweredEdit"));
const Memberlist = lazy(() => import("./pages/ManageMembers/Memberlist"));
const CodeLogin = lazy(() => import("./pages/lywo/CodeLogin"));
const AdditionalInformation = lazy(() => import("./pages/lywo/AdditionalInformation"));
const SplashScreen = lazy(() => import("./pages/lywo/SplashScreen"));
const CompanyName = lazy(() => import("./pages/lywo/CompanyName"));
const Thankyou = lazy(() => import("./pages/lywo/Thank-you"));
const SelfService = lazy(() => import("./pages/lywo/SelfService"));
const WeekAttendance = lazy(() => import("./pages/complaince/employeeWeekAttendance"));

const CompleteWorkFlowChart = lazy(() => import("./pages/workflow/CompleteWorkFlowChart"));
const SubmoddataTest = lazy(() => import("./pages/ChatAdmin/Data Statistics/SubmoduleDataStat"));
const Members = lazy(() => import("./pages/ClientManagement/Members"));
const SubTestCaseStatistics = lazy(() => import("./pages/ChatAdmin/subTestDataStatistics"));
const StockDetails = lazy(() => import("./pages/Inventory Management System/StockData/StockDetails"));
const StoreManage = lazy(() => import("./pages/Inventory Management System/StockData/StoreManage"));
const PrintList = lazy(() => import("./pages/Inventory Management System/Onlineorderactivity/PrintList"));
const ExcelChart = lazy(() => import("./sharedComponent/chartdisplay"));
const SalesGoods = lazy(() => import("./pages/Pristan Management/Sales/SalesGoods"));
const SalseReport = lazy(() => import("./pages/Pristan Management/SalesReport/SalseReport"));
const PurchaseReport = lazy(() => import("./pages/Pristan Management/PurchaseReport/PurchaseReport"));
const SalesServices = lazy(() => import("./pages/Pristan Management/Sales/SalesServices"));
const SalesGoodsList = lazy(() => import("./pages/Pristan Management/Sales/SalesGoodsList"));
const Settings = lazy(() => import("./pages/Pristan Management/settings/Settings"));
const SalesServiceList = lazy(() => import("./pages/Pristan Management/Sales/SalesServiceList"));
const PurchaseGoods = lazy(() => import("./pages/Pristan Management/Purchase/PurchaseGoods"));
const PurchaseServices = lazy(() => import("./pages/Pristan Management/Purchase/PurchaseServices"));
const PurchGoodsList = lazy(() => import("./pages/Pristan Management/Purchase/PurchGoodsList"));
const PurchServiceList = lazy(() => import("./pages/Pristan Management/Purchase/PurchServiceList"));
const ErpManagement = lazy(() => import("./pages/ErpManagement/ErpManagementMod/ErpMana"));
const AddOnSettings = lazy(() => import("./pages/Addon/addon"));
const AddOnSettingsCart = lazy(() => import("./pages/Addon/addonCart"));
const StoreConfig = lazy(() => import("./pages/Inventory Management System/BaseMenu/StoreConfig"));
const AccountServiceReport = lazy(() => import("./pages/AccountServiceReport"));
const ProfitAndLossPage = lazy(() => import("./pages/AccountReport/ProfitAndLossPage"));
const BalanceSheetPage = lazy(() => import("./pages/AccountReport/BalanceSheetPage"));
const CashFlowPage = lazy(() => import("./pages/AccountReport/CashFlowPage"));
const TrialBalancePage = lazy(() => import("./pages/AccountReport/TrialBalancePage"));
const ManualLedgerFormPage = lazy(() => import("./pages/AccountReport/ManualLedgerFormPage"));
const ReclassificationToolPage = lazy(() => import("./pages/AccountReport/ReclassificationToolPage"));
const SalesReport = lazy(() => import("./pages/MyReport"));
const ZamzamSalesReport = lazy(() => import("./pages/Reports/ZamzamSalesReport"));
const ZamzamDayWiseSalesReport = lazy(() => import("./pages/Reports/ZamzamDayWiseReport"));
const CategoryReport = lazy(() => import("./pages/Reports/CategoryReport"));
const OrderSummaryReport = lazy(() => import("./pages/Reports/OrderSummaryReport"));
const InventoryDashboard = lazy(() => import("./pages/Reports/SalesVsMaterialReport"));
const AccessPermission = lazy(() => import("./pages/userManagement/AccessPermission"));
const ReportLReportLayout = lazy(() => import("./pages/Reports/ReportLayout"));

// Wallet - User Pages
const WalletUserDashboard = lazy(() => import("./pages/wallet/user/DashboardPage"));
const WalletWalletsPage = lazy(() => import("./pages/wallet/user/WalletsPage"));
const WalletTopUpPage = lazy(() => import("./pages/wallet/user/TopUpPage"));
const WalletTransferPage = lazy(() => import("./pages/wallet/user/TransferPage"));
const WalletPurchasePage = lazy(() => import("./pages/wallet/user/PurchasePage"));
const WalletWithdrawPage = lazy(() => import("./pages/wallet/user/WithdrawPage"));
const WalletTransactionsPage = lazy(() => import("./pages/wallet/user/TransactionsPage"));

// Wallet - Admin Pages
const WalletAdminDashboard = lazy(() => import("./pages/wallet/admin/AdminDashboardPage"));
const WalletApiKeysPage = lazy(() => import("./pages/wallet/admin/ApiKeysPage"));
const WalletUsersPage = lazy(() => import("./pages/wallet/admin/UsersPage"));
const WalletUserDetailPage = lazy(() => import("./pages/wallet/admin/UserDetailPage"));
const WalletLimitsPage = lazy(() => import("./pages/wallet/admin/WalletLimitsPage"));
const WalletRewardCreditPage = lazy(() => import("./pages/wallet/admin/RewardCreditPage"));
const WalletPayoutsPage = lazy(() => import("./pages/wallet/admin/PayoutsPage"));
const WalletSettlementsPage = lazy(() => import("./pages/wallet/admin/SettlementsPage"));
const WalletRevenueReportPage = lazy(() => import("./pages/wallet/admin/RevenueReportPage"));
const WalletHoldsPage = lazy(() => import("./pages/wallet/admin/HoldsPage"));
const PermissionManagement = lazy(() => import("./pages/Organisation/PermissionManagement"));
const LoginWithOtp = lazy(() => import("./pages/AuthPages/LoginWithOtp"));
const WelletPage = lazy(() => import("./pages/CRMphonebook/WelletPage"));
const PushCampaignsList = lazy(() => import("./pages/CRMphonebook/PushCampaigns/PushCampaignsList"));
const PushCampaignCreate = lazy(() => import("./pages/CRMphonebook/PushCampaigns/PushCampaignCreate"));
const PushGroupsList = lazy(() => import("./pages/CRMphonebook/PushCampaigns/PushGroupsList"));
const PushGroupCreate = lazy(() => import("./pages/CRMphonebook/PushCampaigns/PushGroupCreate"));
const AiSetting = lazy(() => import("./pages/Organisation/AiSetting"));
const ReportLayout = lazy(() => import("./pages/Reports/ReportLayout"));
// ─────────────────────────────────────────────────────────────────

// Suspense fallback shown while a route chunk is being downloaded
const RouteFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "60vh",
      width: "100%",
    }}
  >
    <div className="spinner-border text-primary" role="status" aria-label="Loading">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

// import Header from "./sharedComponent/Header";
function App() {
  const routesWithAndWithoutLogin = [
    "/lywo",
    "/AdditionalInformation",
    "/lywoinfo",
    "/companyname",
    "/ThankYou",
  ];

  const {
    sidebar,
    setSidebar,
    backdrop,
    setbackdrop,
    profile,
    setprofile,
    temp,
    settemp,
    userCalling,
    setOpenSessionLogoutModal,
    permissions,
    setPremissions,
    handleNavigate,
  } = useContext(AppContext);

  const currentRoute = useLocation().pathname;
  const navigate = useNavigate();
  const [theme, setTheme] = useState(
    JSON.parse(
      localStorage.getItem("theme") ? localStorage.getItem("theme") : null
    )
  );
  const [logedIn, setLoggedIn] = useState(
    localStorage.getItem("logedIn") ? localStorage.getItem("logedIn") : false
  );
  const token = localStorage?.Token && localStorage?.Token;
  useEffect(() => {
    const checkTokenExpiration = () => {
      if (token && token) {
        const decode = JSON.parse(atob(token && token?.split(".")[1]));
        if (decode.exp * 1000 < new Date().getTime()) {
          setOpenSessionLogoutModal(true);
        }
      }
    };

    checkTokenExpiration();

    const interval = setInterval(checkTokenExpiration, 10000);

    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    if (routesWithAndWithoutLogin.includes(currentRoute)) {
      navigate(currentRoute);

      return;
    }

    if (!logedIn) {
      if (currentRoute === "/loginWithOtp") {
        return
      }
      if (currentRoute === "/ForgotPassword") {
        navigate("/ForgotPassword");
        return;
      }
      if (currentRoute === "/ChangePassword") {
        navigate("/ChangePassword");
        return;
      }
      if (currentRoute === "/CreateAccount") {
        navigate("/CreateAccount");
        return;
      }
      if (currentRoute === "/OrganizationRegistration") {
        navigate("/OrganizationRegistration");
        return;
      }

      navigate("/");
    } else {
      if (currentRoute === "/" || currentRoute === "/loginWithOtp") {
        // Dashboard
        if (permissions["Employee Wallet"] == true) {
          navigate("/EmpoloyeeWallet");
        } else {
          handleNavigate();
        }
      }
    }

  }, [logedIn]);

  return (
    <WalletAuthProvider>
      <>
        <ToastContainer />
        <div className="App  background_main_wrapper" id="max-width">
          <div
            className={backdrop ? "backdrop-main" : ""}
            onClick={() => {
              setprofile(false);
              settemp(false);
              setbackdrop(false);
            }}
          ></div>

          {currentRoute !== "/" &&
            !currentRoute.includes("/jitsi") &&
            currentRoute !== "/CreateAccount" &&
            currentRoute !== "/ForgotPassword" &&
            currentRoute !== "/ChangePassword" &&
            currentRoute !== "/OrganizationRegistration" &&
            currentRoute !== "/lywo" &&
            currentRoute !== "/AdditionalInformation" &&
            currentRoute !== "/lywoinfo" &&
            currentRoute !== "/companyname" &&
            currentRoute !== "/ThankYou" &&
            currentRoute !== "/loginWithOtp" && (
              <>
                <Header setLoggedIn={setLoggedIn} />
                <Sidebar setLoggedIn={setLoggedIn} />
              </>
            )}
          {userCalling && <Calling />}

          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Login setLoggedIn={setLoggedIn} />} />
              <Route path="/loginWithOtp" element={<LoginWithOtp setLoggedIn={setLoggedIn} />} />
              <Route path="CreateAccount" element={<CreateAccount />} />
              <Route path="ForgotPassword" element={<ForgotPassword />} />
              <Route path="ChangePassword" element={<ChangePassword />} />
              <Route path="WelletPage" element={<WelletPage />} />
              <Route path="PushCampaigns" element={<PushCampaignsList />} />
              <Route path="PushCampaigns/create" element={<PushCampaignCreate />} />
              <Route path="PushGroups" element={<PushGroupsList />} />
              <Route path="PushGroups/create" element={<PushGroupCreate />} />
              <Route
                path="OrganizationRegistration"
                element={<OrganizationRegistration />}
              />
            </Routes>
          </Suspense>

          <Suspense fallback={<RouteFallback />}>
            <Routes>
            {/* ================================ Time Sheet ============================ */}
            <Route path="timesheet" element={<Timesheet />} />
            <Route path="timesheethistory" element={<TimesheetHistory />} />
            <Route path="Achivements" element={<Achivements />} />
            <Route path="MyDiary" element={<MyDiary />} />
            {/* ================================ Role MANAGEMENT ROUTING ============================ */}
            <Route path="Role" element={<Role />} />
            <Route path="AssignRole" element={<AssignRole />} />
            <Route path="Permission" element={<Permission />} />
            <Route path="/Permission1" element={<AccessPermission />} />
            {/* ================================ TASK MANAGEMENT   ROUTING ============================ */}
            <Route path="tasklist" element={<TaskList />} />
            <Route path="task" element={<Task />} />
            <Route path="taskDetails" element={<TaskDetials />} />
            <Route path="leave" element={<Leave />} />
            <Route path="employeeLeave" element={<EmployeeLeave />} />
            <Route path="LeaveApprove" element={<LeaveApprove />} />
            <Route path="TaskApprove" element={<TaskApprove />} />
            <Route path="TaskAllocation" element={<TaskAllocation />} />
            <Route path="AbortTask" element={<AbortTask />} />
            <Route path="HoldTask" element={<HoldTask />} />
            <Route path="StandardTask" element={<StandardTask />} />
            <Route path="CompleteTask" element={<CompleteTask />} />
            <Route path="LeaveSetting333" element={<LeaveSetting />} />
            {/* ================================ TASK MANAGEMENT   ROUTING ============================ */}
            <Route path="ClientManagement" element={<ClientManagement />} />
            <Route path="clientlist" element={<ClientList />} />
            <Route path="Members" element={<Members />} />
            <Route
              path={"servicemapping/:branchId"}
              element={<ServiceMapping />}
            />
            <Route path="subscriptionlist" element={<Subscription />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="clientDetails" element={<ClientDetails />} />
            <Route path="entitieslist/:id" element={<EntitiesList />} />
            <Route path="branch_list/:entityId" element={<BranchList />} />
            <Route path="bank_list/:branchId" element={<BankList />} />
            <Route
              path="shiftmanagement/:branchId"
              element={<ShiftManagment />}
            />
            <Route path="workflowchart" element={<WorkflowChart />} />
            <Route
              path="dynamicComplteTask/:id/:taskAllocationId"
              element={<CompleteTaskDynamic />}
            />
            <Route path="teamtask" element={<TeamTask />} />
            <Route path="projecttask" element={<ProjectTask />} />
            <Route path="salesReport" element={<SalseReport />} />
            <Route path="zamzam-sales-report" element={<ZamzamSalesReport />} />
            <Route path="categories-report" element={<CategoryReport />} />
            <Route path="order-summary-report" element={<OrderSummaryReport />} />
            <Route path="sales-vs-material-report" element={<InventoryDashboard />} />
            <Route path="zamzam-day-wise-report" element={<ZamzamDayWiseSalesReport />} />
            <Route path="purchaseReport" element={<PurchaseReport />} />
            <Route path="SubscriptionMgt" element={<SubcriptionList />} />
            {/* ================================ Notification ROUTING ============================ */}
            <Route path="allAnnouncement" element={<AllAnnouncement />} />
            <Route path="OrgDetails" element={<OrgDetails />} />
            <Route path="ManageDept" element={<ManageDept />} />
            <Route path="ManageDesig" element={<ManageDesig />} />
            <Route path="ManageLoc" element={<ManageLoc />} />
            <Route path="myAnnouncement" element={<MyAnnouncement />} />
            <Route path="holidaysAndEvents" element={<HolidaysAndEvents />} />
            <Route path="Academic" element={<Academic />} />
            <Route path="CalendarSettings" element={<CalendarSettings />} />
            {/* ================================ Notification ROUTING ============================ */}
            {permissions && permissions["View Chat"] && (
              <Route path="chat" element={<Chat />} />
            )}
            {permissions && permissions["View Communication Projects"] && (
              <Route path="projects" element={<ProjectChannels />} />
            )}
            {permissions && permissions["View Teams"] && (
              <Route path="teams" element={<Teams />} />
            )}
            {/* Teams */}
            <Route path="chathistory" element={<ChatHistory />} />
            <Route path="TimesheetApproval" element={<TimesheetApproval />} />
            <Route path="ShortListTask" element={<ShortListTask />} />
            {/* ================================ Attendence ROUTING ============================ */}
            <Route path="attendance" element={<MyAttendence />} />
            <Route path="FaceDetection" element={<FaceDetection />} />
            <Route path="UserTracking" element={<UserTracking />} />
            <Route path="employeeAttendence" element={<EmployeeAttendence />} />
            <Route
              path="EmployeeAttendenceReport"
              element={<EmployeeAttendenceReport />}
            />
            <Route path="Dashboard" element={<Dashboard />} />
            <Route path="/Profile/" element={<Profile />}>
              <Route path=":id" element={<Profile />} />
            </Route>
            <Route path="DevicePunchHistory" element={<DevicePunchHistory />} />
            <Route path="teamChart" element={<TeamChart />} />
            {permissions && permissions["View Calls"] && (
              <Route path="Call" element={<Call />} />
            )}
            {permissions && permissions["View Ongoing Calls"] && (
              <Route path="ongoing-calls" element={<OngoingCalls />} />
            )}
            <Route path="Files" element={<Files />} />
            <Route path="achivements" element={<Achivements />} />
            <Route
              path="jitsi/:call_id/:room_id/:username"
              element={<CallingScreen />}
            />
            {/* ================================ DOCUMENT ROUTING ============================ */}
            <Route path="personal" element={<Personal />} />
            <Route
              path="projectdocumentation"
              element={<ProjectDocumentation />}
            />
            <Route path="projectschedule" element={<ProjectSchedule />} />
            <Route path="projectresources" element={<ProjectResources />} />
            <Route path="Project" element={<Projects />} />
            <Route path="ProjectAssignment" element={<ProjectAssignment />} />
            <Route path="organisational" element={<Organisational />} />
            <Route path="projectdetails" element={<ProjectDetails />} />
            <Route path="TearmsAmdCondiation" element={<TearmsAmdCondiation />} />
            <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="Holidays" element={<Holidays />} />
            <Route path="AboutOrganziation" element={<AboutOrgan />} />
            {permissions && permissions["View Meetings"] && (
              <Route path="meetings" element={<Meetings />} />
            )}
            <Route path="OrganizationDetails" element={<OrganizationDetails />} />
            <Route path="ManageDepartments" element={<ManageDepartments />} />
            <Route path="ManageDesignations" element={<ManageDesignations />} />
            <Route path="ManageLocations" element={<ManageLocations />} />
            <Route path="UserDetails" element={<UserDetails />} />
            <Route path="ManageShift" element={<ManageShift />} />
            <Route path="ShiftMaster" element={<ShiftTime />} />
            <Route path="OrgainsationInfo" element={<OrgDetails />} />
            <Route path="PaymentGateway" element={<PaymentGateway />} />
            <Route path="SMSgateway" element={<SMSGateway />} />
            <Route path="Ivrgetewway" element={<Ivrgetewway />} />
            <Route path="LeaveSetting" element={<LeaveSetting />} />
            <Route path="IVRSetting" element={<IVRSetting />} />

            <Route
              path="EmployeeTimesheetDetails"
              element={<EmployeeTimesheetDetails />}
            />
            <Route
              path="ProjectTimesheetDetails"
              element={<ProjectTimesheetDetails />}
            />
            {/* Complaince */}
            <Route path="TeamNotAssigned" element={<TeamNotAssigned />} />
            <Route path="ProjectNotAssigned" element={<ProjectNotAssigned />} />
            <Route path="ProjectAssigned" element={<ProjectAssigned />} />
            <Route path="ProjectDeAssign" element={<ProjectDeAssign />} />
            <Route
              path="TwoPlusProjectsAssigned"
              element={<TwoPlusProjectsAssigned />}
            />
            <Route
              path="TaskNotAddedAgainstProject"
              element={<TaskNotAddedAgainstProject />}
            />
            <Route path="TaskNotApproved" element={<TaskNotApproved />} />
            <Route path="TaskPlanner" element={<TaskPlanerr />} />
            <Route path="/taskPlanerr" element={<TaskPlanerr />} />
            <Route path="TimesheetNotEntered" element={<TimesheetNotEntered />} />
            <Route
              path="TimesheetNotApproved"
              element={<TimesheetNotApproved />}
            />
            <Route path="TimePeriodOver" element={<TimePeriodOver />} />
            <Route path="BenchList" element={<BenchList />} />
            <Route path="ComplianceSetting" element={<ComplianceSetting />} />
            <Route path="UserNotlogin" element={<UserNotLogin />} />
            <Route path="UserLastLogin" element={<UserLastLogin />} />
            <Route path="UserActivity" element={<UserActivity />} />
            {/* Teams Preference */}
            <Route path="CreateTeam" element={<CreateTeam />} />
            <Route path="ManageTeam" element={<ManageTeam />} />
            <Route path="ExcelChart" element={<ExcelChart />} />
            {/* Project Costing */}
            <Route path="ProjectCost" element={<ProjectCost />} />
            <Route path="ProjectCostReport" element={<ProjectCostReport />} />
            <Route path="/ProjectCostEnd/:id" element={<ProjectCostEnd />} />
            {/* Salary Structure */}
            <Route path="SalaryStructure" element={<SalaryStructure />} />
            <Route path="SalaryStructureWizard" element={<SalaryStructureWizard />} />
            <Route path="GenerateSalarySlip" element={<GenerateSalarySlip />} />
            <Route path="SalaryCalculator" element={<SalaryCalculator />} />
            {/* Employee Structure */}
            <Route path="List" element={<List />} />
            <Route path="AddEmployee" element={<AddEmployee />} />
            <Route
              path="/EditEmployeeProfile/:id"
              element={<EditEmployeeProfile />}
            />
            <Route path="/employeedoucemnt" element={<EmplooyeDocument />} />
            <Route
              path="/AllEmployeeAttendanceReport"
              element={<AddEmployeeAttendanceReport />}
            />
            <Route path="GeneralSetting" element={<GeneralSetting />} />
            <Route path="SalaryMasterRoll" element={<SalaryMasterRoll />} />
            <Route
              path="HourlySalaryMusterRoll"
              element={<HourlySalaryMusterRoll />}
            />
            <Route path="serviceManagement" element={<ServiceGroup />} />
            <Route path="service" element={<Service />} />
            <Route path="ratetable" element={<RateTable />} />
            <Route path="paymentreciept" element={<AccountsPaymentReciept />} />
            <Route path="moneyreciept" element={<AccountsMoneyReciept />} />
            <Route path="invoicegenerate" element={<InvoiceGenerate />} />
            <Route path="generateinvoice" element={<AccountsGenerateInvoice />} />
            <Route path="ledger" element={<Ledger />} />
            <Route path="settlement-report" element={<SettlementReport />} />
            <Route path="viewtransactions/:id" element={<ViewTransactions />} />
            <Route path="/EmployeeCode" element={<EmployeeCode />} />
            <Route path="/createquote" element={<CreateQuote />} />
            <Route path="/quotation" element={<Quotation />} />
            <Route path="/quotationStatus" element={<QuotationStatus />} />
            <Route path="/updatequote" element={<UpdateQuote />} />
            <Route path="/workFlowList" element={<WorkFlow />} />
            <Route path="/executionList" element={<Execution />} />
            <Route path="/definedList" element={<DefineWorkFlow />} />
            <Route path="/workflowEventMapping" element={<WorkFlowMapping />} />
            <Route path="/completedWorkflows" element={<Completedworkflows />} />
            <Route path="/workflowDashboard" element={<Workflowdeshboard />} />
            <Route
              path="/completedWorkflowTask"
              element={<CompleteWorkflowTaskList />}
            />
            <Route path="/statsticsreports" element={<StatisticsReports />} />
            {/* Employee Wallet module */}
            <Route path="EmpoloyeeWallet" element={<EmpoloyeeWallet />} />
            <Route path="RechargeWallet" element={<RechargeWallet />} />
            <Route path="WalletSales" element={<WalletSales />} />
            <Route path="TransactionReceipt" element={<TransactionReceipt />} />
            <Route path="WalletRecharge" element={<WalletRecharge />} />
            <Route path="Store" element={<Store />} />
            <Route path="Categories" element={<Categories />} />
            <Route path="CreateCategories" element={<CreateCategories />} />
            <Route path="Product" element={<Product />} />
            <Route path="ProductStock" element={<ProductStock />} />
            <Route path="AddProductStock" element={<AddProductStock />} />
            <Route path="Canteen" element={<Canteen />} />
            <Route path="IssueCard" element={<IssueCard />} />
            <Route path="CreateProducts" element={<CreateProducts />} />
            <Route path="/WeeklyAttendance" element={<WeekAttendance />} />
            {/* <Route
            path="/EditEmployeeProfile/:id"
            element={<EditEmployeeProfile />}
          /> */}
            {/* ================================ CRM PhoneBook ============================ */}
            {/* ================================ CRM OfficeCaller ============================ */}
            <Route path="CRMDashboard" element={<CRMDashboard />} />
            <Route path="CRMCalls" element={<CRMCalls />} />
            <Route path="LeadManagement" element={<LeadManagement />} />
            <Route
              path="NotCallClassification"
              element={<NotCallClassification />}
            />
            <Route path="RegisterUserDetails" element={<RegisterUserDetails />} />
            <Route path="WhatsappSetting" element={<WhatsappSetting />} />
            <Route path="CreateToken" element={<CreateToken />} />
            <Route path="CreateIVR" element={<CreateIVR />} />
            <Route path="editIVR/:id" element={<UpdateIVR />} />
            <Route path="UserDetailsForm/:id" element={<UserDetailsForm />} />
            <Route path="UpdateUserDetails/:id" element={<UpdateUserDetails />} />
            <Route path="AgentList" element={<AgentList />} />
            <Route path="AgentAssignedCalls" element={<AgentAssignedCalls />} />
            <Route path="CallHistory/:id" element={<CallHistory />} />
            <Route path="Users" element={<Users />} />
            <Route path="UploadCandidateOld" element={<UploadCandidateOld />} />
            <Route path="Domains" element={<Domains />} />
            <Route path="BulkUpload" element={<BulkUpload />} />
            <Route path="ViewDomain" element={<ViewDomain />} />
            <Route path="AssignCallUsers" element={<AssignCallUsers />} />
            <Route path="BulkCallView" element={<BulkCallView />} />
            <Route path="TechCount" element={<TechCount />} />
            <Route path="DownloadAgentReport" element={<DownloadAgentReport />} />
            <Route
              path="LeadManagementListEdit"
              element={<LeadManagementListEdit />}
            />
            <Route path="LeadListCount" element={<LeadListCount />} />
            <Route
              path="SalesInternationalcall"
              element={<SalesInternationalcall />}
            />
            <Route path="Updatewhatsapp/:id" element={<Updatewhatsapp />} />
            <Route path="CrmPushNotification" element={<CrmPushNotification />} />
            <Route path="CrmSendgrid" element={<CrmSendgrid />} />
            <Route path="Addwebsite" element={<Addwebsite />} />
            <Route path="CrmWebsite" element={<CrmWebsite />} />
            <Route path="GoogleAnalytics" element={<GoogleAnalytics />} />
            <Route path="UserdetailsAgent" element={<UserdetailsAgent />} />
            <Route
              path="AgentCallSummaryDetails/:id"
              element={<AgentCallSummaryDetails />}
            />
            <Route path="Adminpanel" element={<Adminpanel />} />
            <Route path="CrmApp" element={<CrmApp />} />
            <Route path="AgentCallSummary" element={<AgentCallSummary />} />
            <Route path="AgentcallList" element={<AgentcallList />} />
            <Route path="EnquiryDetails" element={<EnquiryDetails />} />
            <Route path="FrequentCaller" element={<FrequentCaller />} />
            <Route path="ZeroCallList" element={<ZeroCallList />} />
            <Route path="ServiceRequest" element={<ServiceRequest />} />
            <Route path="CallReport" element={<CallReport />} />
            <Route path="CandidatesData" element={<CandidatesData />} />
            <Route path="InvalidLeads" element={<InvalidLeads />} />
            <Route path="ProposalAttachement" element={<ProposalAttachement />} />
            <Route path="EmailReport" element={<EmailReport />} />
            <Route path="Campaign" element={<Campaign />} />
            <Route path="QueryCases" element={<QueryCases />} />
            <Route path="Admin" element={<Admin />} />
            <Route path="AdminEdit" element={<AdminEdit />} />
            <Route
              path="CategoriesOfficeCaller"
              element={<CategoriesOfficeCaller />}
            />
            <Route
              path="NonFunctionalFeatures"
              element={<NonFunctionalFeatures />}
            />
            {/* Inventory Management System */}
            <Route path="/Stock" element={<Stock />} />

            <Route path="/StockDetails" element={<StockDetails />} />
            <Route path="/StockDetails/:id" element={<StockDetails />} />
            <Route path="/StoreManage" element={<StoreManage />} />
            <Route path="/ManageStore" element={<ManageStore />} />
            <Route path="/AddNewStore/:id" element={<AddNewStore />} />
            <Route path="/AddNewStore" element={<AddNewStore />} />
            <Route
              path="/Onlineorderactivity"
              element={<OnlineOrderActivity />}
            />
            <Route
              path="/printList"
              element={<PrintList />}
            />
            <Route path="/MenuOnOff" element={<MenuOnOff />} />
            <Route path="/BaseMenu" element={<BaseMenu />} />
            <Route path="/AddDiscount" element={<AddDiscount />} />
            <Route path="/AddDiscount/:id" element={<AddDiscount />} />
            <Route path="/Categorymanagement" element={<Categorymanagement />} />
            <Route path="/Editcategory/:id" element={<Editcategory />} />
            <Route path="/Addvariant" element={<Addvariant />} />
            <Route path="/Updatevariant" element={<UpdateVariant />} />
            <Route path="/Addtax" element={<Addtax />} />
            <Route path="/Edittax/:id" element={<Edittax />} />
            <Route path="/AddItems" element={<AddItems />} />
            <Route path="/EditeItem/:id" element={<AddItems />} />
            <Route path="/AddAddon" element={<AddAddon />} />
            <Route path="/AddTable" element={<AddTable />} />
            <Route path="/AddArea" element={<AddArea />} />
            <Route path="ViewCategory" element={<ViewCategory />} />
            <Route path="Modules" element={<Modules />} />
            <Route path="Features" element={<Features />} />
            <Route path="ViewModule" element={<ViewModule />} />
            <Route path="ViewFeatures" element={<ViewFeatures />} />
            <Route
              path="ViewNonFunctionalFeatures"
              element={<ViewNonFunctionalFeatures />}
            />
            <Route path="Consultant" element={<Consultant />} />
            <Route path="Supplier" element={<Supplier />} />
            <Route path="CreateGroup" element={<CreateGroup />} />
            <Route path="EditGroup" element={<EditGroup />} />
            <Route path="ContactCustomGroup" element={<ContactCustomGroup />} />
            <Route path="DefaultGroup" element={<DefaultGroup />} />
            <Route
              path="ContactCustomGroupDetails"
              element={<ContactCustomGroupDetails />}
            />
            <Route path="DefaultGroupDetails" element={<DefaultGroupDetails />} />
            <Route path="WhatsappPromotion" element={<WhatsappPromotion />} />
            <Route
              path="bulkuploadofficecaller"
              element={<BulkUploadOfficeCaller />}
            />
            <Route path="CustomGroup/:id" element={<CustomGroup />} />
            <Route path="/adminChat" element={<AdminChat />} />
            {/* ChatBot Admin New Added */}
            <Route path="/ChatUSer" element={<Chat />} />
            <Route
              path="/setting"
              element={<Setting theme={theme} setTheme={setTheme} />}
            />
            <Route path='/AddonSettings' element={<AddOnSettings />} />
            <Route path="/AddOnSettingsCart" element={<AddOnSettingsCart />} />
            <Route path="/accesscode" element={<AccessCode />} />
            <Route path="/addQuestion" element={<AddQuestions />} />
            <Route path="/editQuestion/:id" element={<AddQuestions />} />
            <Route path="/questionListing" element={<QuestionListing />} />
            <Route
              path="/addSetting"
              element={<AddSettings theme={theme} setTheme={setTheme} />}
            />
            <Route
              path="/addSetting/:id"
              element={<AddSettings theme={theme} setTheme={setTheme} />}
            />
            <Route path="/unAnsweredListing" element={<UnAnsweredListing />} />
            <Route path="/TestunAnsweredCase" element={<TestunAnsweredCase />} />
            <Route path="/TestAnsweredEdit/:id" element={<TestAnsweredEdit />} />
            <Route path="/traineeQues" element={<TraineeQues />} />
            <Route path="/converstionflow" element={<ConversationFlow />} />
            <Route path="/addconverstioflow" element={<AddConversationFlow />} />
            <Route path="/dataStatistics" element={<DataStat />} />
            <Route path="/testCases" element={<TestCases />} />
            <Route path="/EditCase" element={<EditCase />} />
            <Route path="/TestDataStatic" element={<TestDataStatic />} />
            <Route
              path="/submoddataStat/:moduleName"
              element={<SubModuleDataStat />}
            />
            <Route
              path="/SubTestCaseStatistics/:moduleName"
              element={<SubTestCaseStatistics />}
            />
            <Route
              path="/submoddataTest/:moduleName"
              element={<SubmoddataTest />}
            />
            <Route path="/topics/:submodule" element={<Topics />} />
            <Route path="/userfeddback/:submodule" element={<UserFeedBack />} />
            <Route
              path="/userFeedbackList/:submodule/:question"
              element={<UserLikeDislike />}
            />
            {/* ================================ CRM OfficeCaller ============================ */}
            <Route path="/Memberlist" element={<Memberlist />} />
            <Route
              path="/userFeedbackList/:submodule/:question"
              element={<UserLikeDislike />}
            />
            <Route path="/WorkFlowChartss" element={<CompleteWorkFlowChart />} />
            <Route
              path="/WorkFlowChartss/:id"
              element={<CompleteWorkFlowChart />}
            />




            {/* Pristan Mangement */}

            <Route path="/SalesGoods" element={<SalesGoods />} />
            <Route path="SalesServices" element={<SalesServices />} />
            <Route path="sales-goods-invoices" element={<SalesGoodsList />} />
            <Route path="pristan-management-setting" element={<Settings />} />
            <Route
              path="sales-service-invoices"
              element={<SalesServiceList />}
            />

            <Route path="PurchaseServices" element={<PurchaseServices />} />
            <Route path="StoreConfig" element={<StoreConfig />} />
            <Route path="AccountServiceReport" element={<AccountServiceReport />} />
            <Route path="ProfitAndLoss" element={<ProfitAndLossPage />} />
            <Route path="BalanceSheet" element={<BalanceSheetPage />} />
            <Route path="CashFlow" element={<CashFlowPage />} />
            <Route path="TrialBalance" element={<TrialBalancePage />} />
            <Route path="ManualLedgerForm" element={<ManualLedgerFormPage />} />
            <Route path="ReclassificationTool" element={<ReclassificationToolPage />} />



            <Route path="purchaseGoods" element={<PurchaseGoods />} />
            <Route
              path="purchase-goods-invoices"
              element={<PurchGoodsList />}
            />

            <Route
              path="purchase-service-invoices"
              element={<PurchServiceList />}
            />
            {/* Lywo */}
            <Route path="/lywo" element={<CodeLogin />} />
            <Route
              path="/AdditionalInformation"
              element={<AdditionalInformation />}
            />
            <Route path="/lywoinfo" element={<SplashScreen />} />
            <Route path="/CompanyName" element={<CompanyName />} />
            <Route path="/ThankYou" element={<Thankyou />} />
            <Route path="/hrAdmin" element={<SelfService />} />
            <Route path="/ViewList" element={<ViewList />} />


            {/* ERP MANAGEMENT */}

            <Route path="/ErpManagement" element={<ErpManagement />} />


            {/* Reports */}
            <Route path="/Reports" element={<ReportLayout />} />

            {/* ================================ Wallet Module ============================ */}
            {/* Wallet - User Routes */}
            <Route path="/wallet/dashboard" element={<WalletUserDashboard />} />
            <Route path="/wallet/wallets" element={<WalletWalletsPage />} />
            <Route path="/wallet/topup" element={<WalletTopUpPage />} />
            <Route path="/wallet/transfer" element={<WalletTransferPage />} />
            <Route path="/wallet/purchase" element={<WalletPurchasePage />} />
            <Route path="/wallet/withdraw" element={<WalletWithdrawPage />} />
            <Route path="/wallet/transactions" element={<WalletTransactionsPage />} />
            {/* Wallet - Admin Routes */}
            <Route path="/wallet/admin/dashboard" element={<WalletAdminDashboard />} />
            <Route path="/wallet/admin/api-keys" element={<WalletApiKeysPage />} />
            <Route path="/wallet/admin/users" element={<WalletUsersPage />} />
            <Route path="/wallet/admin/users/:userId" element={<WalletUserDetailPage />} />
            <Route path="/wallet/admin/limits" element={<WalletLimitsPage />} />
            <Route path="/wallet/admin/rewards" element={<WalletRewardCreditPage />} />
            <Route path="/wallet/admin/payouts" element={<WalletPayoutsPage />} />
            <Route path="/wallet/admin/settlements" element={<WalletSettlementsPage />} />
            <Route path="/wallet/admin/revenue" element={<WalletRevenueReportPage />} />
            <Route path="/wallet/admin/holds" element={<WalletHoldsPage />} />

            <Route path="/permissionmanagement" element={<PermissionManagement />} />

            {/* AI Setting */}
            <Route path="/Ai-setting" element={<AiSetting />} />

            {/* Dev-only styleguide — not reachable in production */}
            {process.env.NODE_ENV !== 'production' || true && (
              <Route path="/dev/styleguide" element={<Styleguide />} />
            )}

            </Routes>
          </Suspense>
        </div>
      </>
    </WalletAuthProvider>
  );
}

export default App;
